<template>
    <div id="creator-settings" class="modal inmodal fade" role="dialog" aria-hidden="true" data-backdrop="static" tabindex="-1" :style="visible ? 'display: block;' : 'display: none;'">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <div class="modal-header-dialog-painting">
                    <h2 class="modal-title">{{ t_title }}</h2>
                </div>
                <div class="modal-body" :style="'max-height: ' + maxBodyHeight + 'px;'">
                    <div v-if="loading" class="placeholder">
                        <div class="wrapper font-bold" :style="'max-height: ' + maxInnerHeight + 'px;'">
                            <h3><i class="fa fa-spin fa-spinner m-r-sm"></i>{{ t_loading }}</h3>
                        </div>
                    </div>
                    <div v-else class="row design-row" ref="designRow scrollBox">
                        <div class="col-md-12" :style="'max-height: ' + maxInnerHeight + 'px;'">
                            <div class="form-group">
                                <v-select-custom
                                    v-model="layout"
                                    :items="layoutOptions"
                                    :label="t_layout"
                                    style="margin-bottom: 12px;"
                                    popup-used-in-modal
                                />
                                <v-select-custom
                                    v-if="type == 'templatecreator'"
                                    v-model="descriptionSelection"
                                    :items="descriptionOptions"
                                    :label="t_show_description"
                                    popup-used-in-modal
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <v-btn type="button" class="btn btn-primary submit" @click="updateCreatorData">
                        <i v-if="saving" class="fa fa-spin fa-spinner m-r-xs"></i>
                        {{ t_save }}
                    </v-btn>
                    <v-btn type="button" class="btn btn-secondary" data-dismiss="modal">{{ t_cancel }}
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import modalMixin from "../common/modal-mixin";

    export default {
        mixins: [
            modalMixin,
        ],
        props: [
            'type',
            'option-description'
        ],
        components: {
        },
        data: function () {
            return {
                t_loading: Lang.langGet("Loading..."),
                t_title: Lang.langGet("Editor Layout"),
                t_layout: Lang.langGet("Order of Editor Elements in 3-Columns-View"),
                t_close: Lang.langGet("Close"),
                t_cancel: Lang.langGet("Cancel"),
                t_save: Lang.langGet("Save"),
                t_show_description: Lang.langGet("Show Description"),

                strict_mode: false,
                saving: false,
                modalName: 'creator-settings',
                elementsPerRowClass: 'two-in-a-row',

                dragulaObject: null,
                loading: false,

                layout: 'editor-right',

                frameStyles: {},

                layoutOptions: [
                    {
                        value: 'editor-right',
                        text: Lang.langGet('Drag & Drop - Settings - Editor')
                    },
                    {
                        value: 'settings-right',
                        text: Lang.langGet('Drag & Drop - Editor - Settings')
                    }
                ],

                descriptionSelection: this.optionDescription,
                descriptionOptions: [
                    {
                        value: 0,
                        text: Lang.langGet('Never')
                    },
                    {
                        value: 1,
                        text: Lang.langGet('Always')
                    },
                    {
                        value: 2,
                        text: Lang.langGet('When hovered')
                    },
                    {
                        value: 3,
                        text: Lang.langGet('When selected')
                    },
                ],
            }
        },
        watch: {
            maxBodyHeight: function () {
                this.calcFrameStyles();
            },
        },
        methods: {
            calcFrameStyles: function () {
                let height = this.maxInnerHeight - 22 - 10;
                if(this.$refs.titleRow) {
                    height = height -  $(this.$refs.titleRow).outerHeight(true);
                }
                this.frameStyles = {
                    width: `100%`,
                    backgroundColor: `#ffffff`,
                    height: height + 'px'
                }
            },
            updateCreatorData: function () {
                let name = this.type + '-layout-' + Laravel.activeProject;
                localStorage.setItem(name, this.layout);
                EaseEventBus.fire(name, this.layout);
                if(this.type == 'templatecreator') {
                    this.$emit('update:option-description', this.descriptionSelection);
                }
                EaseEventBus.fire('hideModal', this.modalName);
            },
        },
        mounted: function () {
            EaseEventBus.listen('showModal', (modalName) => {
                if (this.modalName === modalName) {
                    let name = this.type + '-layout-' + Laravel.activeProject;
                    let layout = localStorage.getItem(name);
                    this.layout = layout ? layout : 'editor-right';
                    if(this.type == 'templatecreator') {
                        this.descriptionSelection = this.optionDescription;
                    }
                }
            });
        }
    }
</script>
